import template from './solver-progress.html';
import controller from './solver-progress.controller';

import "./solver-progress.styl"

let solverProgressComponent = {
  restrict: 'E',
  bindings: {
  },
  template,
  controller
};

export default solverProgressComponent;



// WEBPACK FOOTER //
// ./client/app/common/solver-progress/solver-progress.component.js